var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0912 6.73992L7.97398 0.622734C7.7293 0.378047 7.38945 0.228516 7.01562 0.228516H2.25781C1.51016 0.228516 0.898438 0.840234 0.898438 1.58789V6.3457C0.898438 6.71953 1.04797 7.05938 1.29945 7.31086L7.41664 13.428C7.66133 13.6727 8.00117 13.8223 8.375 13.8223C8.74883 13.8223 9.08867 13.6727 9.33336 13.4213L14.0912 8.66344C14.3427 8.41875 14.4922 8.07891 14.4922 7.70508C14.4922 7.33125 14.3359 6.98461 14.0912 6.73992ZM8.375 12.4697L2.25781 6.3457V1.58789H7.01562V1.58109L13.1328 7.69828L8.375 12.4697Z",
    fill: "#737791"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/offers.6ad52f298d814b8c22e51eb2ae954576.svg";
export { ForwardRef as ReactComponent };